import React from 'react';
import PropTypes from 'prop-types';

import { injectIntl, intlShape } from 'react-intl';
import { isObject } from 'lodash';

const intlPropTypes = {
  intl: intlShape.isRequired,
  getMessage: PropTypes.func.isRequired,
};

const intlContextTypes = {
  intl: intlShape.isRequired,
  getMessage: PropTypes.func.isRequired,
  getLocalizedData: PropTypes.func,
};

function processNode(node, id = null, output = {}) {
  if (isObject(node)) {
    return Object.keys(node).reduce(
      (all, key) => ({
        ...all,
        ...processNode(node[key], [id, key].filter(val => val).join('.')),
      }),
      output,
    );
  }

  return {
    ...output,
    [id]: node,
  };
}

export { intlPropTypes, processNode, intlContextTypes };
export { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

export default function intl(WrappedComponent) {
  const wmComponent = function WithMessages(props) {
    const { formatMessage } = props.intl;

    const getMessage = (id, ...args) => formatMessage({ id }, ...args);

    return <WrappedComponent getMessage={getMessage} {...props} />;
  };

  wmComponent.propTypes = {
    intl: intlShape.isRequired,
  };

  return injectIntl(wmComponent);
}
